import React from 'react';
import { XButton, XText } from '@orderx/lab/ui';
import { XInputPhone } from '../../../components/x/input/phone/XInputPhone';
import { useFormImmer } from '../../../hooks/form-immer';
import { useMeta } from '../../../hooks/meta';
import { useMe } from '../../../hooks/me';

type Input = {
    isLoading: boolean;
    onNext(params);
};

export function SpcCheckoutPhone({ isLoading, onNext }: Input) {
    const { meta } = useMeta();
    const me = useMe();

    const form = useFormImmer({
        areaCode: me.user?.areaCode || meta?.areaCode,
        phone: me.user?.phone,
    });

    const { areaCode, phone } = form.form;
    const isValid = areaCode && phone?.length > 5;

    return (
        <>
            <XText>
                <b>Make sure your phone number is correct!</b> We will send you link to ticket via SMS. If your number
                is incorrect, you might not be able to access your ticket later
            </XText>

            <XInputPhone
                areaCode={form.form.areaCode}
                phone={form.form.phone}
                onChange={({ areaCode, phone }) => {
                    form.updateField('areaCode')(areaCode);
                    form.updateField('phone')(phone);
                }}
            />

            <XButton
                onClick={() => onNext({ areaCode, phone })}
                isLoading={isLoading}
                disabled={!isValid}
                color={'primary'}>
                Next
            </XButton>
        </>
    );
}
